/** Shared marker for football event binaries and their ladder groups. */
export const CFB_EVENT_SYNTH_MARKER = '|cfb-';

export function cfbEventSynthKey(gameKey: string, cls: string, identity: string): string {
  return `${cfbEventGroupKey(gameKey, cls)}-${identity}`;
}

export function cfbEventGroupKey(gameKey: string, cls: string): string {
  return `${gameKey}${CFB_EVENT_SYNTH_MARKER}${cls}`;
}

export function hasCfbEventSynthKey(key: string): boolean {
  return key.includes(CFB_EVENT_SYNTH_MARKER);
}

/** Negate the complete venue proposition, including compound/Neither outcomes.
 * Never infer that NO means the opposing team wins. */
export function cfbEventNoLabel(yesLabel: string): string {
  return yesLabel.trim() ? `Not: ${yesLabel}` : '';
}

export function cfbEventOutcomeLabel(
  row: { awayName?: string; homeName?: string }, side: 'yes' | 'no',
): string {
  if (!row.awayName?.trim() || !row.homeName?.trim() || row.awayName === row.homeName) {
    return '(outcome unavailable)';
  }
  return `(${side === 'yes' ? row.awayName : row.homeName})`;
}
